






































































































































































































































































































import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import Odontogram from "@/components/pemeriksaan/assesmen/asesmengigi/odontogram/Odontogram.vue";
import { storeAsesmenGigi } from "@/store/modules/asesmengigi";
import { storePasien } from "@/store/modules/pasien";
import { storeToothExam } from "@/store/modules/toothexam";
import type { ToothExam, ToothExamValue } from "@/types/odontogram";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    DokterAutoComplete,
    Odontogram
  }
})
export default class CardOdontogram extends Vue {
  @Ref() diastema_ket: HTMLInputElement;
  @Ref() gigi_anomali_ket: HTMLInputElement;

  items_oklusi = [
    { id: "1", ket: "Normal bite" },
    { id: "2", ket: "Cross Bite" },
    { id: "3", ket: "Step Bite" }
  ];
  items_torus_palatinus = [
    { id: "1", ket: "Tidak ada" },
    { id: "2", ket: "Kecil" },
    { id: "3", ket: "Sedang" },
    { id: "4", ket: "Besar" },
    { id: "5", ket: "Multiple" }
  ];
  items_torus_mandibularis = [
    { id: "1", ket: "Tidak ada" },
    { id: "2", ket: "Sisi kiri" },
    { id: "3", ket: "Sisi kanan" },
    { id: "4", ket: "Kedua sisi" }
  ];
  items_palatum = [
    { id: "1", ket: "Dalam" },
    { id: "2", ket: "Sedang" },
    { id: "3", ket: "Rendah" }
  ];
  items_diastema = [
    { id: "1", ket: "Tidak ada", ket_lain: "" },
    { id: "2", ket: "Ada", ket_lain: "" }
  ];
  items_gigi_anomali = [
    { id: "1", ket: "Tidak ada", ket_lain: "" },
    { id: "2", ket: "Ada", ket_lain: "" }
  ];
  items_jns_photo = [
    { id: "1", ket: "digital" },
    { id: "2", ket: "intraoral" }
  ];
  items_jns_rontgen = [
    { id: "1", ket: "Dental" },
    { id: "2", ket: "PA" },
    { id: "3", ket: "OPG" },
    { id: "4", ket: "Ceph" }
  ];
  show_ket_diastema = false;
  show_ket_gigi_anomali = false;

  private dirty = false;

  mounted() {
    storeToothExam.loadValues();
    if (this.encounterId) {
      storeToothExam.loadForEncounter(this.encounterId);
    }
  }

  get stateAsesmenGigi() {
    return storeAsesmenGigi.asesmenGigi;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get encounterId(): string {
    const s: any = this.stateAsesmenGigi;
    if (s?.register_id) return String(s.register_id);
    const fromRoute = this.$route?.params?.register;
    return fromRoute ? String(fromRoute) : "";
  }

  get isReadonly(): boolean {
    const s: any = this.stateAsesmenGigi;
    return !!(s && (s.is_signed || s.signed_at));
  }

  get toothExams(): ToothExam[] {
    if (storeToothExam.currentEncounterId !== this.encounterId) return [];
    return storeToothExam.toothExams;
  }

  get toothExamValues(): ToothExamValue[] {
    return storeToothExam.toothExamValues;
  }

  @Watch("encounterId")
  onEncounterIdChange(newId: string) {
    if (newId) {
      storeToothExam.loadForEncounter(newId);
    }
  }

  onToothExamsChange(next: ToothExam[]) {
    if (this.isReadonly || !this.encounterId) return;
    // Hanya perbarui state lokal agar chart reaktif; persist ke DB
    // ditunda sampai user menekan tombol "Simpan" (lihat persist()).
    storeToothExam.SET_EXAMS({ encounterId: this.encounterId, exams: next });
    this.dirty = true;
  }

  // Dipanggil oleh form induk saat tombol "Simpan" ditekan.
  async persist(): Promise<void> {
    if (!this.dirty || this.isReadonly || !this.encounterId) return;
    await storeToothExam.saveForEncounter({
      encounterId: this.encounterId,
      exams: this.toothExams
    });
    this.dirty = false;
  }

  @Watch("stateAsesmenGigi.gigi_anomali")
  gigiAnomaliChanged(v) {
    if (v != null && String(v.id) === "2") {
      this.show_ket_gigi_anomali = true;
      this.$nextTick(() => {
        this.gigi_anomali_ket?.focus();
      });
    } else {
      this.show_ket_gigi_anomali = false;
    }
  }

  @Watch("stateAsesmenGigi.diastema")
  diastemaChanged(v) {
    if (v != null && String(v.id) === "2") {
      this.show_ket_diastema = true;
      this.$nextTick(() => {
        this.diastema_ket?.focus();
      });
    } else {
      this.show_ket_diastema = false;
    }
  }

  setDokter(val) {
    this.stateAsesmenGigi["dokter"] = val;
  }
}
